import * as io from 'io-ts';
import { getCurrentAppCodename } from '../app/queries';
import { dispatch } from '../shape/functions';
import { fetchIO, RemoteResource } from '../source';
import {
    ServiceDescription,
    ServiceDescriptionIO,
    ServiceResponse,
} from './io';

export const fetchAllServices = (): Promise<ServiceDescription[]> =>
    fetchIO(
        io.array(ServiceDescriptionIO),
        `/lookup/services/${getCurrentAppCodename()}`,
    );

export const loadAllServices = () =>
    fetchAllServices().then(services => {
        const selected = services.length > 0 ? services[0].code : null;
        dispatch('app/geocoder', ({ response }) => ({
            serviceList: services,
            response,
            selected,
        }));
    });

export const dispatchGeocoderState = (
    response: RemoteResource<ServiceResponse>,
) => {
    dispatch('app/geocoder', ({ serviceList, selected }) => ({
        serviceList,
        response,
        selected,
    }));
};

export const clearServiceResponse = () => {
    dispatch('app/geocoder', ({ serviceList, selected }) => ({
        serviceList,
        response: null,
        selected,
    }));
};

export const selectService = (serviceCode: string) => {
    // clear the results from the previously selected service
    dispatch('app/geocoder', ({ serviceList }) => ({
        serviceList,
        response: null,
        selected: serviceCode,
    }));
};

export const updateTerm = (term: string) => {
    dispatch('app/geocoder/input', () => term);
};
